var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"row-details"},[(_vm.readyToRender)?_c('td',{staticClass:"v-align-middle",attrs:{"colspan":"6"}},[_c('div',{staticClass:"cu-container"},[_c('customer',{attrs:{"customer":_vm.customer,"is-details":_vm.isDetails}}),_vm._v(" "),_c('customer',{attrs:{"customer":_vm.validationRequestable,"is-details":_vm.isDetails}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c827e7c","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/Details/CustomerUpdate.vue
// module id = 1888
// module chunks = 0